export enum EngRegion {
    HK = 'HONG KONG',
    KLN = 'KOWLOON',
    NT = 'NEW TERRITORIES',
}
